import { prepareStackTrace } from 'config/helpers'
import { CONSTS } from 'config/objectConst'
import * as Logs from 'features/logging'
import {
	Navigate,
	type RouteObject,
	useLocation,
	useNavigate
} from 'react-router-dom'
import { FatalError } from 'shared/errors'
import { useMount } from 'shared/hooks'

import { ErrorPage } from './ErrorPage'

function ErrorRoute_() {
	const { state } = useLocation()

	return state?.isFatalError ? <ErrorPage /> : <Navigate to='/campaigns' />
}

function useRejectPromise() {
	const navigate = useNavigate()
	const [log] = Logs.api.useLogsMutation()
	useMount(() => {
		function promiseRejectionHandler(event: PromiseRejectionEvent) {
			const error = event.reason

			if (error instanceof FatalError) {
				navigate('/error', {
					state: {
						isFatalError: true
					}
				})
			}

			if (!CONSTS.LOGS_SETTINGS.rejection) {
				return
			}

			const stackTrace = prepareStackTrace(error)

			if (stackTrace) {
				log({
					args: [
						`${error.name}:${error.message}`,
						stackTrace,
						CONSTS.APP_VERSION
					],
					event_id: 'AppGenericError',
					message: 'Unhandled app error {Message}, {StackTrace},{Version}',
					severity: 'Error'
				})
			}
		}

		window.addEventListener('unhandledrejection', promiseRejectionHandler)

		return () =>
			window.removeEventListener('unhandledrejection', promiseRejectionHandler)
	})
}

const ErrorRoute: RouteObject = {
	Component: ErrorRoute_,
	path: '/error'
}

export { ErrorRoute, useRejectPromise }
